/**
 * Type-safe API client for the Agent Service.
 *
 * Generated from packages/contracts/openapi/agents.yaml using openapi-fetch.
 *
 * ADR-0017 Workstream 2.
 */
import createClient from 'openapi-fetch'
import type { paths } from './generated/agents.d.ts'
import { fetchWithTimeout } from '../lib/fetchWithTimeout'

/**
 * Agent service API client.
 *
 * Browser-only SPA — fetch() resolves relative URLs against the current
 * page origin, so we don't compute a baseUrl from window.location.
 * Agent endpoints are gateway-proxied at /api/agents/*; the OpenAPI
 * paths in agents.d.ts are absolute under that prefix.
 */
export const agentsClient = createClient<paths>({
  credentials: 'include',
  headers: {
    'Content-Type': 'application/json',
  },
  fetch: fetchWithTimeout,
})
